/**
 * DASH-3163: records WHICH EN 689 branch produced a Risk Register's compliance verdict, so the
 * decision narrative can distinguish a preliminary-test pass ("every individual value was below the
 * applicable fraction of the OEL") from a statistical-test verdict ("the decision statistic is below
 * the OEL") instead of inferring it from the magic number 3.
 *
 * Mirrors the backend `Web.Api.Core.Domain.Enums.ComplianceBasis` — ordinals must stay in sync.
 * Nullable on the register: unset until a quantitative compliance calculation runs.
 */
export enum ComplianceBasisEnum {
    NotAssessed = 0,
    PreliminaryTest = 1,
    StatisticalTest = 2,
}
